module.exports = __webpack_public_path__ + "img/sites.ddf0f807.svg";